/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Ledger_To_PlayersInputs */



/**
* | output |
* | --- |
* | "players" |
*
* @param {Promo_Ledger_To_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_ledger_to_players = /** @type {((inputs?: Promo_Ledger_To_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Ledger_To_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("joueurs")
	if (locale === "es") return /** @type {LocalizedString} */ ("jugadores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("jogadores")
	if (locale === "it") return /** @type {LocalizedString} */ ("giocatori")
	return /** @type {LocalizedString} */ ("players")
});